if (!customElements.get('site-carousel')) {
  customElements.define(
    'site-carousel',
    class SiteCarousel extends HTMLElement {
      constructor() {
        super();

        /**
         * @type {HTMLElement | null}
         */
        this.controlNext = this.querySelector('[js-carousel-next]');
        /**
         * @type {HTMLElement | null}
         */
        this.controlPrevious = this.querySelector('[js-carousel-previous]');

        /**
         * @type {HTMLButtonElement | null}
         */
        this.scrollToButton = document.querySelector(`[js-carousel-scroll-to-button="${this.key}"]`);

        this.itemsPerSlide = this.dataset.itemsPerSlide ? parseFloat(this.dataset.itemsPerSlide) : 4;

        if (this.itemsPerSlide === 2) {
          this.itemWidthPercent = 50;
        } else if (this.itemsPerSlide === 2.5) {
          this.itemWidthPercent = 40;
        } else {
          this.itemWidthPercent = 25;
        }

        this.init();

        document.addEventListener('initCarousel', this.init.bind(this));
      }

      /**
       * @param {CustomEvent} [event]
       */
      init(event) {
        if ((event && event.detail.key != this.key) || (!event?.detail && this.isAsync)) return;

        /**
         * @type {HTMLElement | null}
         */
        this.container = this.querySelector('.site-carousel__content');
        this.itemsCount = this.querySelectorAll('.site-carousel__item').length;

        if (this.itemsCount <= this.itemsPerSlide) {
          this.controlNext?.remove();
          this.controlPrevious?.remove();
        } else {
          this.controlNext?.addEventListener('click', this.handleNext.bind(this));
          this.controlPrevious?.addEventListener('click', this.handlePrevious.bind(this));
          this.container?.addEventListener('transitionend', this.checkControls.bind(this));
        }

        this.scrollToButton?.addEventListener('click', () => this.scrollIntoView({ behavior: 'smooth' }));

        document.addEventListener('deviceChanged', this.resetPosition.bind(this));
      }

      handleNext() {
        if (this.currentPosition - this.itemWidthPercent >= -this.containerMaxWidth) {
          this.setPosition(this.currentPosition - this.itemWidthPercent);
        }
      }

      handlePrevious() {
        if (this.currentPosition + this.itemWidthPercent <= 0) {
          this.setPosition(this.currentPosition + this.itemWidthPercent);
        }
      }

      /**
       *
       * @param {HTMLElement} control
       */
      enableControl(control) {
        control.removeAttribute('disabled');
      }

      /**
       *
       * @param {HTMLElement} control
       */
      disableControl(control) {
        control.setAttribute('disabled', 'disabled');
      }

      checkControls() {
        if (!this.controlNext || !this.controlPrevious) return;

        if (this.currentPosition <= -this.containerMaxWidth) {
          this.disableControl(this.controlNext);
          this.enableControl(this.controlPrevious);
        } else if (this.currentPosition >= 0) {
          this.enableControl(this.controlNext);
          this.disableControl(this.controlPrevious);
        } else {
          this.enableControl(this.controlNext);
          this.enableControl(this.controlPrevious);
        }
      }

      /**
       *
       * @param {Number} value
       */
      setPosition(value) {
        if (!this.container) return;

        this.container.style.transform = `translate3d(${value}%, 0 ,0`;
      }

      resetPosition() {
        if (!this.container) return;

        this.container.style.transform = `translate3d(0, 0 ,0`;
        this.container.scrollLeft = 0;
      }

      get key() {
        return this.getAttribute('key') ? this.getAttribute('key') : false;
      }

      get isAsync() {
        return this.dataset.async === 'true';
      }

      get containerMaxWidth() {
        if (!this.itemsCount) return 0;

        const perSlide = this.itemsPerSlide === 2.5 ? 2 : this.itemsPerSlide;

        return this.itemsCount * this.itemWidthPercent - perSlide * this.itemWidthPercent;
      }

      /**
       * @type {Number}
       */
      get currentPosition() {
        if (!this.container) return 0;

        const transformValues = this.container.style.transform.split(/\w+\(|\);?/);

        if (!transformValues[1] || !transformValues[1].length) {
          return 0;
        }

        const translate3dXValue = parseFloat(transformValues[1].split(/,\s?/g)[0]);

        return translate3dXValue;
      }
    },
  );
}
